import React, { useState, useEffect } from "react";
import {
  Typography,
  Paper,
  Select,
  MenuItem,
  OutlinedInput,
  Divider,
  Chip,
  ListSubheader,
  InputAdornment,
  TextField,
  IconButton,
  Autocomplete,
  FormControl,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";
import { ReactComponent as Plant } from "../../assets/images/Plant.svg";
import "../../styles/partCreation.css";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import PartModificationSucess from "./PartModificationSuccess";
import { ToastContainer, toast } from "react-toastify";
import { automationHttpRequest } from "../../api/httpRequests";

const AttributeChange = (props) => {
  const {
    uniqueId,
    materialNumber,
    selectAction,
    handleBackClick,
    handleClose,
  } = props;
  const [noun, setNoun] = useState();
  const [plantName, setPlantName] = useState();
  const [modifier, setModifier] = useState();
  const [nouns, setNouns] = useState([]);
  const [modifiers, setModifiers] = useState([]);
  const [attributes, setAttributes] = useState();
  const [attributeValues, setAttributeValues] = useState({});
  const [uomValues, setUOMValues] = useState({});
  const [attributeValue, setAttributeValue] = useState({});
  const [chipValues, setChipValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [dropdownFetching, setDropdownFetching] = useState(false);
  const [uomValue, setUomValue] = useState({});
  const [updateAttributeValues, setUpdatedAttributeValues] = useState({});
  const [typeAttributeValue, setTypeAttributeValue] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [modifierSearch, setModifierSearch] = useState("");
  const [optionToShow, setOptionToShow] = useState([]);
  const [topAttribute, setTopAttribute] = useState([]);
  const [registeredAttribute, setRegisteredAttribute] = useState({});
  const [attributeTypeValue, setAttributeTypeValue] = useState({});
  const [requestID, setRequestID] = useState(false);
  const [modifyLoader, setModifyLoader] = useState(false);
  const [partModificationDialog, setPartModificationDialog] = useState(false);
  const [cleanLongDescObj, setCleanLongDescObj] = useState([]);
  const [attributeData, setAttributeData] = useState();
  const [cleanShortDescription, setCleanShortDescription] = useState({});
  const [addAttributeValue, setAddAttributeValue] = useState("");
  const [attributeName, setAttributeName] = useState("");
  const [attributeUomValue, setAttributeUoMValue] = useState("");
  const [showUoMInput, setShowUoMInput] = useState(false);
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const [modifyButton, setModifyButton] = useState(false);
  const [attributeDropDown, setAttributeDropDown] = useState([]);
  const [addedAttributes, setaddedAttributes] = useState({});
  // console.log(updateAttributeValues, uomValue)
  const uomOptions = [
    "m", "in", "cm", "mm", "yd", "ft", "tn", "rph", "PULSE/min", "PPR", "m/sec", "fpm", "rpm",  "SHEET", "qt", "pt", "PR", "pc", "oz",
    "mL",
    "m3",
    "lb",
    "L",
    "in3",
    "in",
    "gal",
    "g",
    "cc",
    "kg",
    "N/mm2",
    "N",
    "kN",
    "kgf",
  ];

  useEffect(() => {
    // fetchDefaultAttributeValues();
    fetchAttributeDropDownValues();
    newfetchDefaultAttributeValues()
  }, []);

  useEffect(() => {
    if (uomValue && Object.keys(uomValue)?.length) {
      const mappedObject = Object.fromEntries(
        Object.entries(attributeValue)?.map(([key, value]) => {
          if (Object.keys(uomValue).includes(key)) {
            const result = uomValue[key];
            return [key, `${value} ${result}`];
          } else {
            return [key, value];
          }
        })
      );
      setUpdatedAttributeValues(mappedObject);
    } else {
      setUpdatedAttributeValues(attributeValue);
    }
  }, [attributeValue, uomValue]);

  useEffect(() => {
    const result = chipValues.join(" ");
    setCleanShortDescription(chipValues.join(" "));
  }, [chipValues]);

  useEffect(() => {
    const resultString = cleanLongDescObj.reduce(
      (acc, obj) => ({ ...acc, ...obj }),
      {}
    );
    setAttributeData(resultString);
  }, [cleanLongDescObj]);

  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  };

  const styleInput = {
    display: "flex",
    flexDirection: "column",
    // alignItems: "baseline",
  };

  const modifierInput = {
    margin: "0px 200px 0px",
  };

  const headingStyle = {
    fontSize: 14,
    fontFamily: "Verdana",
    fontWeight: "600",
    // margin: "30px 0px 10px 40px",
  };
  const headingStyleHeading = {
    fontSize: 14,
    fontFamily: "Verdana",
    fontWeight: "600",
    marginLeft: "20px",

    // margin: "30px 0px 10px 40px",
  };
  const headingStyles = {
    fontSize: 14,
    fontFamily: "Verdana",
    fontWeight: "600",
    // margin: "30px 0px 10px 190px",
  };

  const headingStyleNoData = {
    fontSize: 20,
    fontFamily: "Verdana",
    fontWeight: "600",
    margin: "10px 0px 10px 40px",
    color: "#C6003D",
    marginLeft: "500px",
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };

  const uomProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 100,
        marginTop: "4px",
        borderRadius: "10px",
        fontFamily: "Verdana",
      },
    },
  };

  const handleModify = () => {
    // const convertedObject = attributes.reduce((result, currentObject) => {
    //   const key = Object.keys(currentObject)[0];
    //   const value = currentObject[key];
    //   result[key] = value;
    //   return result;
    // }, {});
    setModifyLoader(true);
    updateReplishmentLevel(updateAttributeValues);
  };

  const handleAddAttribute = () => {
    if (attributeName && addAttributeValue) {
      const attributeObject = {};
      attributeObject[
        attributeName
      ] = `${addAttributeValue} ${attributeUomValue}`;
      setaddedAttributes((prev) => ({
        ...prev,...attributeObject
      }))
      // setAttributes((prevAttributes) => [...prevAttributes, attributeObject]);
      setAttributeUoMValue("");
      setAddAttributeValue("");
      setAttributeName("");
      setModifyButton(true);
    }
  };

  const handleAttributeValueChange = (e) => {
    const inputValue = e.target.value;
    setAddAttributeValue(inputValue);
    if (isNaN(inputValue) || inputValue.trim() === "") {
      setShowUoMInput(false);
    } else {
      setShowUoMInput(true);
    }
  };

  const updateReplishmentLevel = async (attributeObject) => {
    try {
      const userEmailId = localStorage.getItem("MRO_user_email");
      const response = await automationHttpRequest.post(
        "/attribute_insert/",
        {
          material_number: materialNumber,
          noun_indentifier: noun,
          modifier: modifier,
          clean_short_description: cleanShortDescription,
          attribute_data: {...attributeObject, ...addedAttributes },
          plant_name: plantName,
          submitted_by: userEmailId,
          type: "attribute",
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        }
      );
      if (response?.data?.status) {
        setRequestID(response?.data?.data.request_id);
        setPartModificationDialog(true);
        setTimeout(() => {
          setModifyLoader(false);
        }, 1200);
      }
    } catch (error) {
      setModifyLoader(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 500,
      });
    }
  };
  //   setFetching(true);
  //   try {
  //     const response = await automationHttpRequest.post(
  //       "/get_attribute_details/",
  //       {},
  //       {
  //         headers: {
  //           session_id: localStorage.getItem("session_id"),
  //           userEmail: localStorage.getItem("MRO_user_email"),
  //         },
  //         params: {
  //           material_number: materialNumber,
  //         },
  //       }
  //     );
  //     if (response?.data?.status) {
  //       if (response?.data?.data?.length > 0) {
  //         setNoun(response?.data?.data[0].noun);
  //         setChipValues([response?.data?.data[0].noun]);
  //         setModifier(response?.data?.data[0].modifier);
  //         setCleanShortDescription(
  //           response?.data?.data[0].clean_short_description.replace(/,/g, " ")
  //         );
  //         setChipValues(
  //           response?.data?.data[0].clean_short_description.split(",")
  //         );
  //         // const attributeValues = Object.entries(
  //         //   response?.data?.data[0].clean_long_description
  //         // ).map(([key, value]) => ({ [key]: value }));
  //         // setAttributes(attributeValues);
  //         setFetching(false);
  //         setPlantName(response?.data?.data[0].plant_name);
  //       } else {
  //         setFetching(false);
  //         setNoDataAvailable(true);
  //       }
  //     }
  //   } catch (error) {
  //     toast.error("Unable get Noun attributes. Please try again!", {
  //       position: toast.POSITION.TOP_CENTER,
  //       autoClose: 800,
  //     });
  //   }
  // };

  const newfetchDefaultAttributeValues = async () => {
    setFetching(true);
    try {
      const response = await automationHttpRequest.post(
        "/get_attribute_details_for_modification/",
        {},
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {
            material_number: materialNumber,
          },
        }
      );
      if (response?.data?.status) {
        // console.log(response?.data?.data)
        if (response?.data?.data?.length > 0) {
          setFetching(false);
          setNoun(response?.data?.data[0].noun);
          setChipValues([response?.data?.data[0].noun]);
          setModifier(response?.data?.data[0].modifier);
          setCleanShortDescription(
            response?.data?.data[0].clean_short_description.replace(/,/g, " ")
          );
          setChipValues(
            response?.data?.data[0].clean_short_description.split(",")
          );
          setPlantName(response?.data?.data[0].plant_name);
          const attributeData = response?.data?.data[0].clean_long_description
          setTopAttribute(
            attributeData?.map((item) => item.attribute_name).slice(0, 4)
          );
          setAttributes(attributeData?.map((item) => item.attribute_name));
          // Create an object to store attribute values
          const attributeValuesObject = {};
          attributeData?.forEach((item) => {
            attributeValuesObject[item.attribute_name] =
              item.attribute_values || [];
          });
          setAttributeValues(attributeValuesObject);
          const uomValuesObject = {};
          attributeData?.forEach((item) => {
            uomValuesObject[item.attribute_name] = item.uom || [];
          });
          const typeValuesObject = {};
          attributeData?.forEach((item) => {
            typeValuesObject[item.attribute_name] = item.type || [];
          });
          setUOMValues(uomValuesObject);
          setTypeAttributeValue(typeValuesObject);
        } else {
          setFetching(false);
          setNoDataAvailable(true);
        }

      }
    } catch (error) {
      toast.error("Unable get Noun attributes. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const fetchAttributeDropDownValues = async () => {
    setDropdownFetching(true);
    try {
      const response = await automationHttpRequest.post(
        "/get_attribute_list_for_dropdown/",
        {},
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {
            material_number: materialNumber,
          },
        }
      );
      if (response?.data?.status) {
        setAttributeDropDown(response?.data?.data)
        setDropdownFetching(false);
      }
    } catch (error) {
      toast.error("Unable get Noun attributes. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const handleAttributeChange = (attribute, value, type) => {
    let attributeKey = attribute.toString();

    if (type === "UOMChange") {

      setUomValue((prevAttributeValue) => ({
        ...prevAttributeValue,
        [attribute]: value,
      }));
  
      // Check if the attribute already exists
      if (attributeValues.hasOwnProperty(attributeKey)) {
        setAttributeTypeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
      } else {
        // If the attribute doesn't exist, add it
        setAttributeTypeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
      }
    } else {
      if(type === "nonSelect") {
        const isValid = /^[0-9,/.\\-\s]*$/.test(value);
        if (isValid) {
        setAttributeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));
       }
      }else {
        setAttributeValue((prevAttributeValue) => ({
          ...prevAttributeValue,
          [attributeKey]: value,
        }));     
       }
     
      // Check if the attributeKey already exists
      if (attributeValues.hasOwnProperty(attributeKey)) {
        if(type === "nonSelect"){
          const isValid = /^[0-9,/.\\-\s]*$/.test(value);
        if (isValid) {
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: value,
          }));
         }
        }else {
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: value,
          }));
        }
       
      } else {
        // If the attributeKey doesn't exist, add it
        if(type === "nonSelect"){
          const isValid = /^[0-9,/.\\-\s]*$/.test(value);
        if (isValid) {
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: value,
          }));
         }
        }
        else{
          setAttributeTypeValue((prevAttributeValue) => ({
            ...prevAttributeValue,
            [attributeKey]: value,
          }));
         }
      }
    }
    setModifyButton(true)
    
  };

  const handleUomChange = (attribute, value) => {
    setUomValue((prevAttributeValue) => ({
      ...prevAttributeValue,
      [attribute]: value,
    }));
    // if (chipValues?.length < 6) {
    //   setChipValues([...chipValues, value]);
    // }
  };

  const handleReset = () => {
    // setNouns([]);
    // setModifiers([]);
    // setNoun();
    // setPlantName();
    // setModifier();
    // setAttributes([]);
    // setAttributeValues({});
    // setChipValues([]);
    // setRegisteredAttribute({});
    // setCleanLongDescObj([]);
    setaddedAttributes({})
    setUomValue({})
    setAttributeTypeValue({})
    setAttributeValue({})
    // newfetchDefaultAttributeValues();
    setModifyButton(false)
  };

  const handleNext = () => {
    // handleContinue()
  };

  const handlechipsValues = (values) => {
    const val = values.join(" ");
    localStorage.setItem("shortDesc", val);
    return val;
  };

  const handleChange = (event) => {
    setAttributeUoMValue(event?.target?.value);
  };

  const handleSearchTerm = (event) => {
    event.preventDefault();
    // setSearchTerm(event?.target?.value)
    const value = nouns.filter((option) =>
      option.toLowerCase().includes(event?.target?.value.toLowerCase())
    );
    setOptionToShow(value.slice(0, 100));
  };

  const headingStyleAttribute = {
    fontSize: 13,
    fontFamily: "Verdana",
    fontWeight: "600",
    margin: "30px 0px 10px 0px",
  };

  return (
    <>
      <div>
        <button
          style={{
            display: "flex",
            width: "90px",
            justifyContent: "space-around",
            alignItems: "center",
            border: "0px",
            background: "transparent",
            margin: "0px 0px 20px 0px",
            cursor: "pointer",
          }}
          onClick={() => handleBackClick()}
        >
          <ArrowBackIcon />
          <Typography> Back </Typography>
        </button>
      </div>
      <Paper
        sx={{
          width: "100%",
          margin: "20px 0px",
          borderRadius: "18px",
        }}
        elevation={2}
      >
        {(fetching || dropdownFetching)? (
          <>
            <Typography
              sx={{
                // height: "70px",
                fontSize: "18px",
                padding: "20px",
                background: "#fff",
                fontFamily: "Verdana",
              }}
            >
              Loading...
            </Typography>
          </>
        ) : (
          <>
            {noDataAvailable ? (
              <Typography style={headingStyleNoData}>
                No Data Available
              </Typography>
            ) : (
              <>
                <div style={{ margin: "25px 40px 40px 40px", paddingTop: "5px" }}>
                  <Typography
                    sx={{
                      fontFamily: "Verdana",
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#C6003D",
                      margin: "20px 0px"
                    }}
                  >
                    Add New Data Attributes
                  </Typography>
                  {noun && (
                    <div>
                      <Divider />
                      <div style={inputStyle}>
                        {/* <Typography style={headingStyle}>
                          Description
                        </Typography> */}
                        <Typography
                          style={{
                            fontFamily: "Verdana",
                            margin: "10px 0px 10px 0px",
                            fontWeight: 600,
                          }}
                        >
                          Short Description
                        </Typography>
                      </div>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            border: "1px solid #BDBDBD",
                            borderRadius: "8px",
                            padding: "10px",
                          }}
                        >
                          <Typography className="shortDesc">
                            {handlechipsValues(chipValues)}
                          </Typography>
                        </div>

                        {modifier && (
                          <>
                            {false && <p>Loading...</p>}
                            <>
                              <Typography
                                style={{
                                  fontFamily: "Verdana",
                                  fontWeight: 600,
                                  margin: "10px 0px 10px 0px",
                                }}
                              >
                                Data Attributes
                              </Typography>
                              <div
                                style={{
                                  // display: "flex",
                                  // flexWrap: "wrap",
                                  border: "1px solid #BDBDBD",
                                  borderRadius: "8px",
                                  padding: "20px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "baseline",
                                    gap: "1px",
                                  }}
                                >
                                  <Typography
                                    style={{
                                      marginBottom: "10px",
                                      marginLeft: "10px",
                                      fontFamily: "Verdana",
                                      background: "#EFEFEF",
                                      padding: "10px",
                                      fontSize: "13px",
                                      borderRadius: "8px",
                                      width: "fit-content",
                                    }}
                                  >
                                    {noun} {modifier}
                                  </Typography>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "baseline",
                                    gap: "2px",
                                    marginBottom: "15px"
                                  }}
                                >
                                  <Typography
                                    style={{
                                      fontFamily: "Verdana",
                                      margin: "10px 0px",
                                      marginLeft: "10px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Add Attribute
                                  </Typography>
                                  <FormControl sx={{ ml: 4, width: "150px" }}>
                                    <Select
                                      value={attributeName}
                                      name="baseUOM"
                                      onChange={(e) =>
                                        setAttributeName(
                                          e.target.value.toUpperCase()
                                        )
                                      }
                                      IconComponent={() => (
                                        <DropdownIcon
                                          style={{
                                            width: "30px",
                                            position: "relative",
                                            left: "-10px",
                                          }}
                                        />
                                      )}
                                      MenuProps={MenuProps}
                                      sx={{ height: "32px", borderRadius: "8px" }}
                                    >
                                      {attributeDropDown?.map((option) => (
                                        <MenuItem key={option} value={option}>
                                          {option}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  <input
                                    placeholder="Value"
                                    autoComplete="off"
                                    value={addAttributeValue}
                                    onChange={handleAttributeValueChange}
                                    style={{
                                      borderRadius: "8px",
                                      marginRight: "2px",
                                      fontFamily: "Verdana",
                                      padding: "6px 10px",
                                      height: "32px",
                                      outlineStyle: "none",
                                      border: "1px solid #cbc3c3",
                                      width: "100px",
                                    }}
                                  />
                                  {showUoMInput && (
                                    <>
                                      <FormControl sx={{ m: 1, width: "100px" }}>
                                        <Select
                                          value={attributeUomValue}
                                          name="baseUOM"
                                          onChange={handleChange}
                                          IconComponent={() => (
                                            <DropdownIcon
                                              style={{
                                                width: "30px",
                                                position: "relative",
                                                left: "-10px",
                                              }}
                                            />
                                          )}
                                          MenuProps={MenuProps}
                                          sx={{ height: "32px", borderRadius: "8px" }}
                                        >
                                          {uomOptions?.map((option) => (
                                            <MenuItem key={option} value={option}>
                                              {option}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </>
                                  )}
                                  <button
                                    type="submit"
                                    className="submitButton"
                                    style={{
                                      fontSize: 16,
                                      cursor: "pointer",
                                      // position: "relative",
                                      fontFamily: "Verdana",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleAddAttribute();
                                    }}
                                    disabled={false}
                                  >
                                    Add
                                  </button>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {attributes?.map((attribute) => (
                                    <div
                                      key={attribute}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "baseline",
                                        width: "48%",
                                        margin: "0px 10px",
                                      }}
                                    >
                                      <Typography
                                        style={headingStyleAttribute}
                                        sx={{ width: "250px" }}
                                      >
                                        {attribute}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          margin:
                                            uomValues[attribute]?.length > 0
                                              ? "0px 0px 0px 0px "
                                              : null,
                                        }}
                                      >
                                        :-
                                      </Typography>
                                      {typeAttributeValue[attribute] ===
                                        "string" ? (
                                        <>
                                          <div style={{ position: "relative" }}>
                                            <>
                                              <Select
                                                displayEmpty
                                                sx={{
                                                  height: "32px",
                                                  borderRadius: "8px",
                                                  width:
                                                    uomValues[attribute]?.length >
                                                      0
                                                      ? "120px"
                                                      : "200px",
                                                  background: "#FFFFFF",
                                                  left:
                                                    uomValues[attribute]?.length >
                                                      0
                                                      ? "25px"
                                                      : "0px",
                                                  margin:
                                                    uomValues[attribute]?.length >
                                                      0
                                                      ? "10px 0px 10px 22px "
                                                      : "10px 30px",
                                                }}
                                                value={
                                                  attributeValue[attribute] || ""
                                                }
                                                onChange={(event) =>
                                                  handleAttributeChange(
                                                    attribute,
                                                    event.target.value,
                                                    "select"
                                                  )
                                                }
                                                inputProps={{
                                                  "aria-label": "Without label",
                                                }}
                                                input={<OutlinedInput />}
                                                IconComponent={() => (
                                                  <DropdownIcon
                                                    style={{
                                                      width: "20px",
                                                      position: "relative",
                                                      left: "-10px",
                                                    }}
                                                  />
                                                )}
                                                MenuProps={MenuProps}
                                              >
                                                <MenuItem disabled value="">
                                                  <span
                                                    style={{ color: "#333333" }}
                                                  >
                                                    Select
                                                  </span>
                                                </MenuItem>
                                                {attributeValues[attribute]?.map(
                                                  (value) => (
                                                    <MenuItem
                                                      key={value}
                                                      value={value}
                                                    >
                                                      {value}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </Select>
                                            </>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div style={{ position: "relative" }}>
                                            <input
                                              placeholder="Enter Value"
                                              name={attribute}
                                              autoComplete="off"
                                              type="text" // Change type to text
                                              pattern="[0-9,/.\\-\s]*"
                                              inputmode="numeric"
                                              className="uomInputValue"
                                              onChange={(event) =>
                                                handleAttributeChange(
                                                  attribute,
                                                  event.target.value,
                                                  "nonSelect"
                                                )
                                              }
                                              value={
                                                attributeTypeValue[attribute]
                                              }
                                              style={{
                                                // left:
                                                //   uomValues[attribute]?.length > 0
                                                //     ? "10px"
                                                //     : "0px",
                                                // margin:
                                                //   uomValues[attribute]?.length > 0
                                                //     ? "10px 0px 10px 22px "
                                                //     : "10px 30px",
                                                borderRadius: "8px",
                                                padding: "6px 10px",
                                                margin: "10px 110px 10px 32px",
                                                height: "32px",
                                                width: "120px",
                                                position: "relative",
                                                top: "-2px",
                                                outlineStyle: "none",
                                                border: "1px solid #cbc3c3",
                                              }}
                                            />
                                            {uomValues[attribute]?.length > 0 && (
                                              <>
                                                <div>
                                                  <Typography
                                                    style={{
                                                      fontFamily: "Verdana",
                                                      // background: "#EFEFEF",
                                                      fontSize: "13px",
                                                      position: "absolute",
                                                      top: "-16px",
                                                      right: "60px",
                                                      fontWeight: "560",
                                                    }}
                                                  >
                                                    UOM
                                                  </Typography>
                                                  <Select
                                                    displayEmpty
                                                    sx={{
                                                      height: "32px",
                                                      borderRadius: "8px",
                                                      width: "80.2px",
                                                      background: "#FFFFFF",
                                                      margin: "10px 0px",
                                                      right: "28px",
                                                      top: "-2px",
                                                      position: "absolute",
                                                    }}
                                                    value={
                                                      attributeTypeValue[
                                                      attribute + "UOM"
                                                      ] || ""
                                                    }
                                                    onChange={(event) =>
                                                      handleAttributeChange(
                                                        attribute,
                                                        event.target.value,
                                                        "UOMChange"
                                                      )
                                                    }
                                                    inputProps={{
                                                      "aria-label":
                                                        "Without label",
                                                    }}
                                                    input={<OutlinedInput />}
                                                    IconComponent={() => (
                                                      <DropdownIcon
                                                        style={{
                                                          width: "20px",
                                                          position: "relative",
                                                          left: "-10px",
                                                        }}
                                                      />
                                                    )}
                                                    MenuProps={uomProps}
                                                  >
                                                    <MenuItem disabled value="">
                                                      <span
                                                        style={{
                                                          color: "#333333",
                                                        }}
                                                      >
                                                        Select
                                                      </span>
                                                    </MenuItem>
                                                    {uomValues[attribute]?.map(
                                                      (value) => (
                                                        <MenuItem
                                                          key={value}
                                                          value={value}
                                                        >
                                                          {value}
                                                        </MenuItem>
                                                      )
                                                    )}
                                                  </Select>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ))}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {Object.keys(addedAttributes)?.map((attribute, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        // justifyContent: "space-between",
                                        alignItems: "baseline",
                                        width: "48%",
                                        margin: "0px 10px",
                                      }}
                                    >
                                      <Typography
                                        style={headingStyleAttribute}
                                        sx={{ width: "250px" }}
                                      >
                                        {attribute}
                                      </Typography>
                                      <Typography>
                                        :-
                                      </Typography>
                                      <Typography  style={{
                                        margin: "0px 36px",
                                      }}>
                                        {addedAttributes?.[attribute]}
                                      </Typography>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  <div style={{ margin: "25px 0px", display: "flex", justifyContent: "center", position: "relative", bottom: "10px" }}>
                    <button
                      type="submit"
                      className="submitButton"
                      style={{
                        fontSize: 16,
                        cursor: modifyButton ? "pointer" : "default",
                        position: "relative",
                        fontFamily: "Verdana",
                        background: !modifyButton ? "#f5f5f5" : "#C6003D",
                        color: modifyButton ? "#FFFFFF" : "#C6003D",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleModify();
                      }}
                      disabled={!modifyButton}
                    >
                      {modifyLoader ? (
                        // Render loader or loading state here
                        <div>Loading...</div>
                      ) : (
                        // Render button text
                        "Modify"
                      )}
                    </button>
                    <button
                      type="submit"
                      className="cancelButton"
                      style={{
                        fontSize: 16,
                        cursor: "pointer",
                        position: "relative",
                        fontFamily: "Verdana",
                      }}
                      onClick={(e) => {
                        handleReset();
                      }}
                    >
                      Reset
                    </button>
                    <button
                      type="submit"
                      className="cancelButton"
                      style={{
                        fontSize: 16,
                        cursor: "pointer",
                        position: "relative",
                        fontFamily: "Verdana",
                      }}
                      onClick={(e) => {
                        handleBackClick()
                        handleReset();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <PartModificationSucess
                  partModificationDialog={partModificationDialog}
                  setPartModificationDialog={setPartModificationDialog}
                  requestID={requestID}
                  handleClose={handleClose}
                />
              </>
            )}
          </>
        )}
      </Paper>
    </>
  );
};

export default AttributeChange;
